export const spicyPhrases = [
  "Eu nunca paguei peitinho para ter bebida grátis.",
  "Eu nunca brochei.",
  "Eu nunca chamei o nome errado durante o sexo.",
  "Eu nunca fiquei com alguém da minha família.",
  "Eu nunca enviei uma mensagem quente para o número errado.",
  "Eu nunca tive sexo com alguém com o dobro da minha idade.",
  "Eu nunca pensei que podia ter uma DST.",
  "Eu nunca usei um objeto comum como brinquedo sexual e coloquei de volta.",
  "Eu nunca fiz sexo a 3.",
  "Eu nunca desejei ou fiquei com alguém do mesmo sexo.",
  "Eu nunca me masturbei ao ar livre.",
  "Eu nunca me exibi na webcam.",
  "Eu nunca fui infiel.",
  "Eu nunca fiz sexo na cama dos meus pais.",
  "Eu nunca transei na praia.",
  "Eu nunca tomei banho com outra pessoa.",
  "Eu nunca nadei pelado.",
  "Eu nunca fiquei com @ ex de um(a) amig@.",
  "Eu nunca fiquei com alguém dessa roda.",
  "Eu nunca fiz sexo anal.",
  "Eu nunca dei um beijo de Singapura.",
  "Eu nunca fiz sexo menstruada.",
  "Eu nunca fiz greve de sexo.",
  "Eu nunca fiz um strip tease.",
  "Eu nunca fingi um orgasmo.",
  "Eu nunca usei uma camisinha que brilha no escuro.",
  "Eu nunca me fantasiei de algo muito zoado para satisfazer alguém na cama.",
  "Eu nunca transei em uma suíte com espelho no teto.",
  "Eu nunca fui a um motel drive in.",
  "Eu nunca participei do surubão de Noronha.",
  "Eu nunca deixei marca de chupão em alguém.",
  "Eu nunca odiei um apelido carinhoso de alguém.",
  "Eu nunca desconfiei do meu parceiro.",
  "Eu nunca tive um namorado virtual.",
  "Eu nunca tive vergonha de revelar uma fantasia sexual.",
  "Eu nunca fiz sexo tântrico.",
  "Eu nunca imaginei meu/minha namorad@ com outra pesoa.",
  "Eu nunca imaginei nós dois fazendo uma coisa muito safada.",
  "Eu nunca usei algo afrodisíaco.",
  "Eu nunca inventei uma desculpa esfarrapada para não transar.",
  "Eu nunca tive vontade de ir a uma casa de swing.",
  "Eu nunca usei vibrador enquanto estava com meu namorado.",
  "Eu nunca fiz algo constrangedor para agradar meu/minha parceiro.",
  "Eu nunca tive nojo de sêmen.",
  "Eu nunca tive nojo de menstruação.",
  "Eu nunca pensei que eu fosse viciad@ em sexo.",
  "Eu nunca usei um estimulador de clítoris.",
  "Eu nunca recebi um massagem erótica.",
  "Eu nunca usei máscaras na cama.",
  "Eu nunca testei uma posição sexual perigosa.",
  "Eu nunca pensei em outra pessoa enquanto me masturbava.",
  "Eu nunca tive vergonha de pedir alguma coisa na cama.",
  "Eu nunca pratiquei pompoarismo.",
  "Eu nunca pensei em fazer sexo anal.",
  "Eu nunca dominei uma pessoa na cama.",
  "Eu nunca fui dominad@ por alguém na cama.",
  "Eu nunca recebi uma massagem tailandesa.",
  "Eu nunca transei em quarto iluminado à luz de velas.",
  "Eu nunca falei sacanagem durante o sexo.",
  "Eu nunca fiz uma rapidinha.",
  "Eu nunca gozei de verdade.",
  "Eu nunca transei fora de casa.",
  "Eu nunca fiquei com alguém 10 anos mais velho do que eu.",
  "Eu nunca fiquei excitado com algum cheiro.",
  "Eu nunca tive vergonha da minha cara enquanto eu gozo.",
  "Eu nunca terminei com alguém porque a pessoa era ruim de cama.",
  "Eu nunca fiz sexo enquanto estava bebad@.",
  "Eu nunca fiz garganta profunda.",
  "Eu nunca transei na água.",
  "Eu nunca me excitei com a voz de alguém.",
  "Eu nunca senti dor enquanto transava.",
  "Eu nunca tentei apimentar a relação.",
  "Eu nunca entendi a diferença entre amor e paixão.",
  "Eu nunca fiz um anal giratório.",
  "Eu nunca recebi uma massagem yoni.",
  "Eu nunca usei lubrificante.",
  "Eu nunca tive um orgasmo mental.",
  "Eu nunca usei uma cadeira erótica.",
  "Eu nunca fiz um fio-terra.",
  "Eu nunca transei na frente de alguém.",
  "Eu nunca fui a uma praia nudista.",
  "Eu nunca me masturbei no chuveiro.",
  "Eu nunca provoquei uma pessoa.",
  "Eu nunca usei um vibrador líquido.",
  "Eu nunca fiz exerícios de Kegel.",
  "Eu nunca vesti algo só para seduzir alguém.",
  "Eu nunca estive na friend zone de alguém.",
  "Eu nunca fiz bondage.",
  "Eu nunca fiz sexo na balada.",
  "Eu nunca gozei só com 1 beijo.",
  "Eu nunca li contos eróticos.",
  "Eu nunca escrevi contos eróticos.",
  "Eu nunca dei um presente erótico.",
  "Eu nunca fui em um encontro às cegas.",
  "Eu nunca tentei controlar um orgasmo.",
  "Eu nunca dormi de conchinha.",
  "Eu nunca me considerei bom/boa de cama.",
  "Eu nunca encontrei meu ponto G.",
  "Eu nunca fiz fotos eróticas.",
];
